<template>
  <div
    class="sb-key-value"
    data-sb-regression="sb-key-value"
  >
    <SbKeyValueContainer
      type="key"
      :emphasis="internalEmphasis"
      :emphasis-type="internalEmphasisType"
    >
      <!--
          @slot text, components, or HtmlElements as children of the component
        -->
      <slot name="key" />
    </SbKeyValueContainer>
    <SbKeyValueContainer
      type="value"
      :emphasis="internalEmphasis"
      :emphasis-type="internalEmphasisType"
    >
      <!--
          @slot text, components, or HtmlElements as children of the component
        -->
      <slot name="value" />
    </SbKeyValueContainer>
  </div>
</template>

<script>
import SbKeyValueContainer from '@src/components/KeyValue/components/SbKeyValueContainer.vue';

export default {
  name: 'SbKeyValue',
  components: { SbKeyValueContainer },
  inject: {
    emphasizer: {
      default: {},
    },
  },
  props: {
    /**
    * Whether to emphasise on key or value of the pair
    */
    emphasis: {
      type: String,
      default: 'key',
      validator: (val) => val.match(/(key|value)/),
    },
    /**
    * Whether to emphasise via color or a bold font
    */
    emphasisType: {
      type: String,
      default: 'color',
      validator: (val) => val.match(/(color|bold)/),
    },
  },
  computed: {
    internalEmphasis() {
      return (this.emphasizer && this.emphasizer.emphasis) || this.emphasis;
    },
    internalEmphasisType() {
      return (this.emphasizer && this.emphasizer.emphasisType) || this.emphasisType;
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/KeyValue/style/sb-key-value.scss';
</style>
